<template>
    <div class="x_box">
        <ol class="breadcrumb x_breadcrumb">
            <li class="breadcrumb-item">
                <router-link to="/setting">{{ $t('setting') }}</router-link>
            </li>
            <li class="breadcrumb-item active" aria-current="page">{{ $t('config_number') }}</li>
        </ol>
        <div class="x_header">
            <button type="button" class="btn btn-outline-primary btn-sm no-bor" @click="$router.go(-1)"><i class="fa fa-arrow-circle-o-left"></i> {{ $t('back') }}</button>
            <button @click="$refs.form.show()" class="btn btn-outline-primary btn-sm no-bor"><i class="fa fa-plus-circle"></i> {{$t('new')}}</button>
        </div>
        <div class="x_body">
            <div class="card x_card">
                <div class="card-body">
                    <table class="table table-bordered table-striped table-sm no-bor">
                        <thead>
                        <tr>
                            <th style="width: 60px" class="text-center">{{ $t('no') }}</th>
                            <th style="width: 300px">{{ $t('name') }}</th>
                            <th>{{ $t('prefix') }}</th>
                            <th>{{ $t('year') }}</th>
                            <th>{{ $t('length') }}</th>
                            <th>{{ $t('next_number') }}</th>
                            <th>{{ $t('example') }}</th>
                            <th style="width: 40px;"></th>
                        </tr>
                        </thead>
                        <tbody>
                        <tr v-for="(ret, index) in records" :key="index">
                            <td class="text-center">{{index+1}}</td>
                            <td>{{ ret.Name }}</td>
                            <td>{{ret.Prefix}}</td>
                            <td>{{ret.Year}}</td>
                            <td>{{ret.Length}}</td>
                            <td>{{ret.LastValue}}</td>
                            <td>{{ ret.Prefix + ret.Year + String(ret.LastValue).padStart(ret.Length, '0') }}</td>
                            <td class="text-center">
                                <button type="button" class="btn btn-outline-info btn-sm btn-xs" @click="onShow(ret)"><i class="fa fa-pencil"></i></button>
                            </td>
                        </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
        <b-modal title="Setup Number" ref="form" centered>
            <div class="row">
                <div class="col-sm-12 form-group">
                    <label class="form-control-label blue">{{  $t('name') }}</label>
                    <input type="text" class="form-control form-control-sm" v-model="model.Name"/>
                </div>
            </div>
            <div class="row">
                <div class="col-sm-4 form-group">
                    <label class="form-control-label blue">{{  $t('prefix') }}</label>
                    <input type="text" class="form-control form-control-sm" v-model="model.Prefix"/>
                </div>
                <div class="col-sm-4 form-group">
                    <label class="form-control-label blue">{{  $t('year') }}</label>
                    <input type="text" class="form-control form-control-sm" v-model="model.Year"/>
                </div>
                <div class="col-sm-4 form-group">
                    <label class="form-control-label blue">{{  $t('next_number') }}</label>
                    <input type="text" class="form-control form-control-sm" v-model="model.LastValue"/>
                </div>
            </div>
            <div slot="modal-footer">
                <b-btn variant="primary" size="sm" @click="onSave"><i class="fa fa-floppy-o" aria-hidden="true"></i> {{$t('save')}}</b-btn>
            </div>
        </b-modal>
    </div>
</template>
<script>
export default {
    data(){
        return {
            query: {
                CompanyId: this.$store.state.company.Id
            },
            records: [],
            model: {}
        }
    },
    created(){
        this.toList();
    },
    methods: {
        toList(){
            var loading = this.$loading.show();
            this.$api().post('setting/config-num', this.query).then(res => {
                if(this.$isValid(res)){
                    this.records = res.data.Json.Configs;
                }
            }).finally(function() { loading.hide(); });
        },
        onShow(n){
            this.model = JSON.parse(JSON.stringify(n));
            this.$refs.form.show();
        },
        onSave(){
            var loading = this.$loading.show();
            this.$api().post('setting/save-config-num', this.model).then(res => {
                if (this.$isValid(res)) {
                    this.$refs.form.hide();
                    this.toList();
                }
            }).finally(function () { loading.hide(); });
        }
    }
}
</script>